import { useAppSelector } from 'src/reducer/hooks';
import { selectRawAllProgram } from 'src/reducer/programSlice';

function useVipLevels() {
  const rawAllProgram = useAppSelector(selectRawAllProgram);

  const getEnumVipLevels = () => {
    if (!rawAllProgram || rawAllProgram.length === 0) return {};

    return rawAllProgram.reduce((acc: any, { vipLevel }) => {
      return {
        ...acc,
        [vipLevel]: vipLevel,
      };
    }, {});
  };

  return { EnumVipLevels: getEnumVipLevels() };
}

export default useVipLevels;
